import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';

const MeuPerfil = lazy(() => import('./MeuPerfil'));
const ComoFunciona = lazy(() => import('./ComoFunciona'));
const Admin = lazy(() => import('./Admin'));
const SavedViews = lazy(() => import('./SavedViews'));
const Vinculos = lazy(() => import('./Vinculos'));

export const eliteRoutes: RouteObject[] = [
    {
        path: '/elite',
        element: (
            <ProtectedRoute permission="elite.access">
                <MeuPerfil />
            </ProtectedRoute>
        ),
    },
    {
        path: '/elite/vinculos',
        element: (
            <ProtectedRoute permission="bi.hierarquia.view">
                <Vinculos />
            </ProtectedRoute>
        ),
    },
    {
        // Visões montadas à mão: valem só pra quem ainda não está na Hierarquia (transição).
        path: '/elite/visoes',
        element: (
            <ProtectedRoute permission="elite.views.manage">
                <SavedViews />
            </ProtectedRoute>
        ),
    },
    {
        path: '/elite/admin',
        element: (
            <ProtectedRoute permission="elite.payment">
                <Admin />
            </ProtectedRoute>
        ),
    },
    {
        path: '/elite/como-funciona',
        element: (
            <ProtectedRoute permission="elite.access">
                <ComoFunciona />
            </ProtectedRoute>
        ),
    },
];
